export class RoamingCommunityModel {
  virtId: string;
  name: string;
  protocolVersion: string;
  cDate: number;
  uDate: number;
  deleted: boolean;

  constructor(name: string = "", protocolVersion: string = '1.1') {
    this.virtId = "";
    this.name = name;
    this.protocolVersion = protocolVersion;
    this.cDate = 0;
    this.uDate = 0;
    this.deleted = false;
  }
}
